module.exports = __webpack_public_path__ + "img/nosave_icon.4f218545.png";